import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { EnvironmentResource } from '@lib.resources/environment/resource';

@Injectable({
  providedIn: 'root'
})
export class ResourceRegistry {
  private readonly environmentResource$$ = new BehaviorSubject<EnvironmentResource | undefined>(undefined);
  private readonly environmentResource$ = this.environmentResource$$.asObservable();

  getEnvironmentResource(): Observable<EnvironmentResource> {
    return this.environmentResource$.pipe(filter(rsc => rsc !== undefined));
  }

  setEnvironmentResource(environmentResource: EnvironmentResource) {
    this.environmentResource$$.next(environmentResource);
  }
}